import { useTranslation } from '@mint-lib/i18n';

export const useCustomMetricsTypesLabelsByName = () => {
  const { t } = useTranslation('@myn/import-hub');

  return {
    number: t('Number'),
    currency: t('Currency'),
  };
};
